import { useCallback, useEffect, useState } from "react";

import { FileType, SocialMediaData } from "../../../models";
import { getDevelopmentManagerDetails } from "../../../service/query";
import { Status } from "../../../service/Shared";
import { useAuth } from "../../../useAuth";

export interface DevelopmentManagerChrome {
  displayName: string | null;
  logo: string | null;
  websiteUrl: string | null;
}

interface UsePublicDevelopmentManagerDetailsPreviewTemplateReturnData {
  dataIsLoading: boolean;
  developmentManagerUuid: string | undefined | null;
  developmentManagerDetails: DevelopmentManagerChrome | undefined;
  developmentManagerSocialMedia: SocialMediaData | undefined;
}

export const usePublicDevelopmentManagerDetailsPreviewTemplate =
  (): UsePublicDevelopmentManagerDetailsPreviewTemplateReturnData => {
    const { currentDevelopmentManagerUuid } = useAuth();

    const [dataIsLoading, setDataIsLoading] = useState(true);
    const [developmentManagerDetails, setDevelopmentManagerDetails] = useState<DevelopmentManagerChrome | undefined>();
    const [developmentManagerSocialMedia, setDevelopmentManagerSocialMedia] = useState<SocialMediaData | undefined>();

    const fetchData = useCallback(async (): Promise<void> => {
      if (currentDevelopmentManagerUuid) {
        const res = await getDevelopmentManagerDetails({
          developmentManagerUuid: currentDevelopmentManagerUuid,
        });

        if (res.status === Status.Success && res.data) {
          const logo = res.data.files.find((f) => f.type === FileType.LargeLogo)?.file.url || null;

          setDevelopmentManagerDetails({
            displayName: res.data.displayName,
            logo,
            websiteUrl: res.data.websiteUrl,
          });

          setDevelopmentManagerSocialMedia({
            twitterUsername: res.data.socialMediaTwitterUsername,
            linkedinURL: res.data.socialMediaLinkedInUrl,
            instagramUsername: res.data.socialMediaInstagramUsername,
            youtubeChannel: res.data.socialMediaYoutubeChannel,
            facebookURL: res.data.socialMediaFacebookUrl,
          });
        }
      }
    }, []);

    useEffect(() => {
      fetchData().then(() => setDataIsLoading(false));
    }, [fetchData]);

    return {
      dataIsLoading,
      developmentManagerUuid: currentDevelopmentManagerUuid,
      developmentManagerDetails,
      developmentManagerSocialMedia,
    };
  };
